<template>
	<div class="contacts main-content-padding">
		<Panel :contentPaddingTop="12">
			<BreadCrumb slot="header"></BreadCrumb>
			<div class="mt-12 yx-form-wrap">
				<el-form inline :model="form" label-width="96px">
					<el-form-item label="联系人名称">
						<el-input v-model="form.contact_name" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="关联达人名称">
						<el-input v-model="form.anchor_name" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="微信昵称">
						<el-input v-model="form.nick_name" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="微信号">
						<el-input v-model="form.wechat_account" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="form.mobile" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="绑定微信">
						<el-select v-model="form.is_bind" clearable placeholder="请选择">
							<el-option v-for="(item, index) in bindWechatList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="绑定时间">
						<el-date-picker
							v-model="bindTime"
							type="daterange"
							@change="changTime($event, 'bindTime')"
							value-format="timestamp"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getContactList(true)">筛 选</el-button>
						<el-button @click="onClear">清 空</el-button>
					</el-form-item>
				</el-form>
			</div>
		</Panel>
		<Panel :contentPaddingTop="5">
			<div class="mt-24" v-if="$auth.hasPermi('system:talnetContacts:add-edit')">
				<el-button type="primary" @click="showAddContactDialog">添加联系人</el-button>
			</div>
			<multi-table class="mt-16" ref="multiTable" :page="pageInfo" :list="list" :columns="columns" @gePartnerList="gePartnerPage" :total="total">
			</multi-table>
		</Panel>
		<add-contact ref="addContactDialog" @refresh="getContactList" />
		<relevance-talent-dialog ref="relevanceTalentDialog" @getList="getContactList" />
		<editContactDialog ref="editContactDialog" @getList="getContactList"></editContactDialog>
		<detail-drawer ref="detailDrawer" @getList="getContactList" />
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import { getContactList, addwxfriend } from '@/api/talentCRM';
import addContact from '@/views/common/dialog/addContact';
import editContactDialog from './components/editContactDialog';
import relevanceTalentDialog from './components/relevanceTalentDialog';
import talentInfo from './components/talentInfo';
import detailDrawer from '../components/detailDrawer';
import { columns } from './columns';
import { startOfDay, endOfDay } from 'date-fns';
export default {
	name: 'contacts',
	components: {
		editContactDialog,
		addContact,
		relevanceTalentDialog,
		talentInfo,
		detailDrawer
	},
	created() {
		this.contact_id = this.$route.query?.contact_id;
		this.getContactList();
	},
	computed: {
		...mapState(['vuex_userId']),
		...mapGetters(['isBoss']),
		columns() {
			return columns
				.map(item => {
					return {
						...item,
						isAuth: item.auth ? this.$auth.hasPermi(item.auth) : true,
					};
				})
				.filter(item => item.isAuth);
		},
	},
	provide() {
		return {
			showdetailDrawer: this.showdetailDrawer,
			refresh: this.getContactList,
		};
	},
	data() {
		return {
			bindTime: [],
			bindWechatList: [
				{ value: 0, label: '全部' },
				{ value: 1, label: '已绑定' },
				{ value: 2, label: '未绑定' },
			],
			form: {
				contact_name: '',
				anchor_name: '',
				nick_name: '',
				wechat_account: '',
				mobile: '',
				is_bind: 0,
				add_time_start: 0,
				add_time_end: 0,
			},
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			contact_id: '',
		};
	},
	methods: {
		changTime(val, flag) {
			const setTime = ([startTime, endTime], start, end) => {
				this.form[start] = startTime && Math.trunc(startOfDay(startTime) / 1000);
				this.form[end] = endTime && Math.trunc(endOfDay(endTime) / 1000);
			};
			const obj = {
				bindTime: time => setTime(time, 'add_time_start', 'add_time_end'),
			};
			obj[flag](val || ['', '']);
		},
		getContactList: throttle(async function (isInit) {
			isInit && this.resetPage();
			const { form, pageInfo } = this;
			const { code, data: { list = [], page = {} } = {} } = await getContactList({ ...form, ...pageInfo, contact_id: this.contact_id });
			if (code !== 0) return;
			this.list = list.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			this.total = page.item_total;
		}, 1000),
		async radioFun(row) {
			const { code } = await addwxfriend({ is_add_wx: row.is_add_wx, contact_id: row.id });
			if (code === 0) {
				this.$message.success('修改成功');
				this.getContactList();
			}
		},
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '关联达人',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talnetContacts:Connected') && this.isSelf(item.user_id),
					click: row => this.showRelevanceTalentDialog(row.id, row.anchor_info),
				},
				{
					label: '合作进度',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => {
						if (!this.$auth.hasPermi('system:cooperationProgress-query')) {
							this.$message.warning('暂无合作进度页面权限');
							return;
						}
						const { href } = this.$router.resolve({ path: '/cooperationProgress/list' });
						window.open(href, '_blank');
					},
				},
				{
					label: '修改联系人信息',
					type: 'text',
					classtype: 2,
					isShow: (this.isBoss || this.isSelf(item.user_id)) && this.$auth.hasPermi('system:talnetContacts:add-edit'),
					click: row => this.editContact(row),
				},
			);
			return arr.filter(v => v.isShow);
		},
		resetPage() {
			this.pageInfo.page_index = 1;
			this.$refs.multiTable.resetPage();
		},
		onClear() {
			this.form = {
				contact_name: '',
				anchor_name: '',
				nick_name: '',
				wechat_account: '',
				mobile: '',
				is_bind: 0,
				add_time_start: 0,
				add_time_end: 0,
			};
			this.bindTime = [];
			this.getContactList(true);
		},
		gePartnerPage(val) {
			const { page_index, page_size } = val;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getContactList();
		},
		showAddContactDialog() {
			this.$refs.addContactDialog.show();
		},
		showRelevanceTalentDialog(id, anchor_info) {
			anchor_info = anchor_info.map(item => item.anchor_id);
			this.$refs.relevanceTalentDialog.show(id, anchor_info);
		},
		goToUrl(path) {
			if (!this.$auth.hasPermi('system:cooperationProgress-query')) {
				this.$message.warning('暂无合作进度页面权限');
				return;
			}
			const { href } = this.$router.resolve({ path });
			window.open(href, '_blank');
		},
		editContact(row) {
			this.$refs.editContactDialog.show(row);
		},
		showdetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
	},
};
</script>

<style lang="less" scoped>
.contacts {
	.talent-info {
		display: flex;

		.el-image {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			margin-top: 4px;
		}

		.right {
			margin-left: 8px;
			font-size: 14px;
			color: #666;
			flex: 1;
			overflow: hidden;

			.ellipsis {
				color: #333;
			}
		}
	}

	.green {
		color: #0fb820;
	}

	.red {
		color: #fa2714;
	}
}
/deep/ .el-table__fixed {
	box-shadow: 8px 3px 7px rgba(0, 0, 0, 0.08);
}
/deep/ .el-table__fixed-right {
	box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.08);
}
</style>
